/** Explicit route classification: demos never enter normal SIIS event reporting. */
export const DEMO_ROUTES = ["/athlete-profile-demo", "/athlete-business-hub-demo"] as const;
export const isDemoRoute = (pathname: string) =>
  DEMO_ROUTES.some((route) => pathname.split(/[?#]/)[0].replace(/\/+$/, "") === route);
export const demoTrafficClass = (pathname: string) => isDemoRoute(pathname) ? "test" : "public";